import { all, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import { propOr, map, path, values, compose, pipe, addIndex, mergeAll } from 'ramda';
import { MarketTypes, MarketActions } from './market.redux';
import * as Contentful from '../../shared/services/contentful';
import { ContentRegistryActions, selectMarketsIds, selectMarketSlugs } from '../contentRegistry';
import normalizeData from '../../shared/utils/normalizeData';
import history from '../../shared/utils/history';
import { ROUTES } from '../../routes/routes';
import { selectCurrentMarketData } from './market.selectors';

function* setCurrentMarketBySlug({ slug }) {
  if (slug) {
    const { [slug]: marketId } = yield select(selectMarketSlugs);
    yield put(MarketActions.setCurrentMarketId(marketId));

    const marketData = yield select(selectCurrentMarketData);

    if (!marketData) {
      history.push(ROUTES.notFound);
    }
  } else {
    yield put(MarketActions.setCurrentMarketId(null));
  }
}

function* fetchMarketSuggestedExperiences({ market }) {
  const data = yield Contentful.fetchMarketSuggestedExperiences(market);
  const ids = compose(
    map(path(['sys', 'id'])),
    values,
    propOr([], 'items')
  )(data);
  yield put(ContentRegistryActions.addEntities(normalizeData(data)));
  yield put(MarketActions.setMarketSuggestedExperiences(market, ids));
}

function* fetchMarketsExperiencesTotal() {
  const marketsIds = yield select(selectMarketsIds);

  const data = yield all(marketsIds.map(id => Contentful.fetchMarketExperiencesTotal(id)));
  const marketExperiencesTotal = pipe(
    addIndex(map)((id, index) => ({ [id]: data[index].total })),
    mergeAll
  )(marketsIds);

  yield put(MarketActions.setMarketExperiencesTotal(marketExperiencesTotal));
}

export default function* startupSaga() {
  yield all([
    takeEvery(MarketTypes.FETCH_MARKET_SUGGESTED_EXPERIENCES, fetchMarketSuggestedExperiences),
    takeLatest(MarketTypes.SET_CURRENT_MARKET_BY_SLUG, setCurrentMarketBySlug),
    takeLatest(MarketTypes.FETCH_MARKETS_EXPERIENCES_TOTAL, fetchMarketsExperiencesTotal),
  ]);
}
